import { useContext } from 'react';

import { Navigate } from '@sorare/routing';
import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { ANY_SPORT_MY_CARDS_REVEALABLE_CARDS_TYPE } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import { MyCardsLayoutContext } from '#src/layouts/my-cards/MyCardsLayout/MyCardsLayoutContext.tsx';

const REVEALABLE_RARITIES: Rarity[] = [
  Rarity.limited,
  Rarity.rare,
  Rarity.super_rare,
  Rarity.unique,
];

export const CardsPage = () => {
  const { defaultRarity } = useContext(MyCardsLayoutContext);
  const { generateSportContextPath } = useSportContext();
  const rarity = REVEALABLE_RARITIES.includes(defaultRarity)
    ? defaultRarity
    : Rarity.limited;
  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_MY_CARDS_REVEALABLE_CARDS_TYPE, {
        params: {
          type: rarity,
        },
      })}
      replace
    />
  );
};

export default CardsPage;
